import useSWR from 'swr';
import api from '../services/api';

const fetchHorarios = async ([, codMedico, diaSemana]) => {
  const response = await api.get('horarios', {
    params: { codMedico, diaSemana },
  });
  return response.data;
};

const useHorarios = (enabled, codMedico, diaSemana) => {
  const shouldFetch = enabled && codMedico && diaSemana;

  return useSWR(shouldFetch ? ['horarios', codMedico, diaSemana] : null, fetchHorarios, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
  });
};

export default useHorarios;
